import { render, staticRenderFns } from "./Patologias.vue?vue&type=template&id=b9523b40"
import script from "./Patologias.vue?vue&type=script&lang=js"
export * from "./Patologias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports